import {SortDirection} from '@mui/material';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';
import {AppState} from '../../store';
import {defaultPageSetting, PageHeaderSettingState, ViewType} from './types';

const initialState: PageHeaderSettingState = {
  pageSettings: [],
};

export const pageSettingSlice = createSlice({
  name: 'pageSetting',
  initialState,
  reducers: {
    toggleView: (state, action: PayloadAction<{value: ViewType; key: string}>) => {
      let settingExist = state.pageSettings.find((setting) => setting.key === action.payload.key);
      if (settingExist) {
        settingExist.itemView = action.payload.value;
      } else {
        state.pageSettings.push(defaultPageSetting(action.payload.key));
      }
    },
    searchChanged: (state, action: PayloadAction<{value: string; key: string}>) => {
      let settingExist = state.pageSettings.find((setting) => setting.key === action.payload.key);
      if (settingExist) {
        settingExist.searchString = action.payload.value;
      } else {
        state.pageSettings.push(defaultPageSetting(action.payload.key));
      }
    },
    toggleSort: (state, action: PayloadAction<{value: SortDirection; key: string}>) => {
      let settingExist = state.pageSettings.find((setting) => setting.key === action.payload.key);
      if (settingExist) {
        settingExist.sort = action.payload.value;
      } else {
        state.pageSettings.push(defaultPageSetting(action.payload.key));
      }
    },
  },
});

export const selectPageSetting = (store: AppState) => store.pageSettingReducer.pageSettings;

export const selectPageSettingByKey = (key?: string) =>
  createSelector(selectPageSetting, (settings) => {
    return settings.find((setting) => setting.key === key);
  });

export const {toggleView, searchChanged, toggleSort} = pageSettingSlice.actions;

export default pageSettingSlice.reducer;
